import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  isSupported as isAnalyticsSupported,
} from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken } from "firebase/messaging";
// Imported required Auth modules for v10
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Initialize Firebase Authentication and Providers
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const appleProvider = new OAuthProvider("apple.com");

// Add optional scopes to retrieve additional user data
googleProvider.addScope("email");
googleProvider.addScope("profile");
appleProvider.addScope("email");
appleProvider.addScope("name");

// Force Google to prompt for account selection every time
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

let analytics = null;
isAnalyticsSupported().then((supported) => {
  if (supported) analytics = getAnalytics(app);
});

let messaging = null;
try {
  if (
    typeof window !== "undefined" &&
    "Notification" in window &&
    "serviceWorker" in navigator
  ) {
    messaging = getMessaging(app);
  }
} catch (error) {
  console.warn(
    "Firebase Messaging is not supported on this browser/device.",
    error,
  );
}

// Export auth and providers
export {
  app,
  analytics,
  db,
  messaging,
  getToken,
  auth,
  googleProvider,
  appleProvider,
};
